export default "__VITE_ASSET__aeafa860__"